import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { LoginService } from '../services/login.service';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { ConfiguracaoVisualService } from '../services/configuracaoVisual.service';
import { MatDialog } from '@angular/material';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CriptoService } from '../services/cripto.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { EnvioCodigoRequest, CodigoResponse, ValidacaoCodigoRequest } from '../modelo/tokenSmsEmail';

declare var $: any;

@Component({
  selector: 'app-primeiro-acesso-token',
  templateUrl: './primeiro-acesso-token.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService, ConfiguracaoVisualService, RestClientService, MensagemService, CriptoService],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PrimeiroAcessoTokenComponent extends AbstractComponent implements OnInit {

  public cpfCnpj: string = '';
  public codAcesso: string = '';
  public enableRead: boolean = true;
  public opcoes: Array<any> = [];
  public isLoaded: boolean = false;
  public hideBtnCod: boolean = false;
  public mensagemBox: string = '';
  public btdis: boolean = false;
  public isSelectEmail: boolean = false;
  public isSelectSms: boolean = false;

  @ViewChild('inputCodAcesso') inputCodigo: ElementRef | undefined;

  /**
   * Construtor padrão
   */
  constructor(
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private mensagemService: MensagemService,
    private sessaoService: SessaoService,
    private loginService: LoginService,
    private spinnerService: Ng4LoadingSpinnerService,
    private configuracaoVisualService: ConfiguracaoVisualService,
    public dialog: MatDialog,
    private criptoService: CriptoService) {
    super(sessaoService);
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {

    this.cpfCnpj = this.sessao.autenticado.nuCpfCnpj || '';
    this.carregarDadosEnvioToken();

    var WindowsSize = function () {
      // Toggle menu abrir conforme a resolucao
      var h = $('.loginBox').height(),
        w = $(window).width();

      // Conteudo altura
      $(".login").css('height', h + 200);
      $(".footer").css('width', w);
    };

    $(document).ready(WindowsSize);
    $(window).resize(WindowsSize);

    this.spinnerService.hide();
    this.isLoaded = true;
  }

  /**
   * Confirmação de token e redirect para a home
   */
  onClickAvancar = (): void => {
    this.btdis = true;
    this.campos = [];
    this.mensagemService.clear();
    if (this.codAcesso) {
      this.validarToken();
    } else {
      this.campos.push("codAcesso");
      this.mensagemService.show(this.campos);
      this.btdis = false;
    }
  }

  /**
   * Aciona a api para validação do token digitado
   */
  validarToken() {
    const validacaoTokenRequest: ValidacaoCodigoRequest = {
      codigoToken: this.codAcesso,
      nuCTRL: this.sessao.autenticado.nuCTRL
    }

    this.loginService.validarToken(validacaoTokenRequest).subscribe(
      (result: CodigoResponse) => {
        this.spinnerService.hide();
        if (result.cdMsgemRetorno === '0') {
          this.router.navigate(['/BF-Portal', 'home']);
        } else {
          if (this.inputCodigo) this.inputCodigo.nativeElement.focus();
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno,
              codigo: result.cdMsgemRetorno,
            }
          });
        }
      },
      () => {
        this.mensagemService.servicoIndisponivelPrimeiroAcesso(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
        this.btdis = false;
      }
    );
  }

  /**
   * Clique do botão voltar
   */
  onClickVoltar = (): void => {
    window.history.back();
  }


  /**
   * Exibe o modal com a mensagem de atualização de dados
   */
  abrirModal() {
    this.campos = [];
    this.mensagemService.clear();
    this.dialog.open(BraAlertComponent, {
      width: Config.POPUP_50VW,
      data: {
        mensagem: this.getMensagem("MSG_ATUALIZAR_DADOS"),
        erro: false,
        linkChat: true
      }
    });
  }

  /**
   * Formatação cpf/cnpj
   */
  formatarCpfCnpj(nuCpfCnpj: string, cdTipoCpfCnpj: string) {
    if (cdTipoCpfCnpj === 'J') {
      while (nuCpfCnpj.length < 14) {
        nuCpfCnpj = '0' + nuCpfCnpj;
      }
      nuCpfCnpj = nuCpfCnpj.substring(0, 2) + '.' + nuCpfCnpj.substring(2, 5) + '.'
        + nuCpfCnpj.substring(5, 8) + '/' + nuCpfCnpj.substring(8, 12)
        + '-' + nuCpfCnpj.substring(13);
    } else {
      while (nuCpfCnpj.length < 11) {
        nuCpfCnpj = '0' + nuCpfCnpj;
      }
      nuCpfCnpj = nuCpfCnpj.substring(0, 3) + '.' + nuCpfCnpj.substring(3, 6) + '.'
        + nuCpfCnpj.substring(6, 9) + '-' + nuCpfCnpj.substring(9);
    }
    this.cpfCnpj = nuCpfCnpj;
  }

  /**
   * Inicialza as opcoes de envio de token
   */
  carregarDadosEnvioToken() {
    this.opcoes = [];
    this.sessao.autenticado.cdTipoCpfCnpj === 'F' ? this.tratarDadosEnvioPF() :this.tratarDadosEnvioPJ();
  }

  /**
   * Tratar dados de envio para clientes pessoa juridica
   */
  tratarDadosEnvioPJ() {
    this.mensagemBox = this.getMensagem("MSG_NAO_EMAIL");
    this.isSelectSms = false;
    if (this.sessao.autenticado.nmEmail) {
      this.opcoes.push({ value: 'E-mail', content: this.sessao.autenticado.nmEmail, default: true });
      this.isSelectEmail = true;
      this.mensagemBox = this.getMensagem("MSG_CONFERIR_DADOS");
    }
  }

  /**
  * Tratar dados de envio para clientes pessoa fisica
  */
  tratarDadosEnvioPF() {
    this.mensagemBox = this.getMensagem("MSG_NAO_EMAIL_CELULAR");
    if (this.sessao.autenticado.nuCelular) {
      this.opcoes.push({ value: 'SMS', content: (this.sessao.autenticado.nuDdd || '') + (this.sessao.autenticado.nuCelular || ''), default: true });
      this.opcoes.push({ value: 'E-mail', content: this.sessao.autenticado.nmEmail, default: false });
      this.isSelectSms = true;
      this.isSelectEmail = false;
      this.mensagemBox = !this.sessao.autenticado.nmEmail ?
        this.getMensagem("MSG_NAO_EMAIL") : this.getMensagem("MSG_CONFERIR_DADOS");
    } else if (this.sessao.autenticado.nmEmail) {
      this.opcoes.push({ value: 'SMS', content: (this.sessao.autenticado.nuDdd || '') + (this.sessao.autenticado.nuCelular || ''), default: false });
      this.opcoes.push({ value: 'E-mail', content: this.sessao.autenticado.nmEmail, default: true });
      this.isSelectSms = false;
      this.isSelectEmail = true;
      this.mensagemBox = !this.sessao.autenticado.nuCelular ?
        this.getMensagem("MSG_NAO_CELULAR") : this.getMensagem("MSG_CONFERIR_DADOS");
    }
  }


  /**
   * Faz o envio do token para o e-mail/celular cadastrado
   */
  enviarCodigo() {
    const requestToken: EnvioCodigoRequest = {
      email: this.isSelectEmail,
      sms: this.isSelectSms,
      nuCTRL: this.sessao.autenticado.nuCTRL
    }

    this.loginService.receberToken(requestToken).subscribe(
      (result: CodigoResponse) => {
        this.spinnerService.hide();
        if (result.cdMsgemRetorno === '0') {
          this.hideBtnCod = true;
          this.enableRead = false;
        } else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno,
              codigo: result.cdMsgemRetorno,
            }
          });
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Habilita o botão 'Enviar codigo' quando o contador finaliza
   */
  onCountdownFinished(finished: boolean) {
    this.hideBtnCod = !finished;
    this.codAcesso = '';
    this.enableRead = true;
  }

  /**
   * Controla a seleção na mudança do radio select
   */
  onSelectValueChange(value: string) {
    if (value === 'SMS') {
      this.isSelectSms = true;
      this.isSelectEmail = false;
    } else {
      this.isSelectSms = false;
      this.isSelectEmail = true;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/login/primeiro-acesso-token.component.ts